import { supabase } from '../supabaseClient';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;

export const reviewService = {
  /**
   * Check if current user is a reviewer
   * Anyone with access to the system can review
   */
  async isReviewer(): Promise<boolean> {
    const { data: { user } } = await supabase.auth.getUser();
    return !!user; // Anyone authenticated can review
  },

  /**
   * Submit contract for review (sends email to selected reviewers)
   */
  async submitForReview(
    contractId: string, 
    reviewers: Array<{ email: string; name: string }>
  ): Promise<void> {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Not authenticated');

    const response = await fetch(`${SUPABASE_URL}/functions/v1/send-review-email`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ contractId, reviewers }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to send review email');
    }

    return await response.json();
  },

  /**
   * Approve contract
   */
  async approveContract(contractId: string): Promise<void> {
    const { error } = await supabase
      .from('contracts')
      .update({ status: 'signature' })
      .eq('id', contractId);

    if (error) throw error;
  },

  /**
   * Reject contract (move back to draft)
   */
  async rejectContract(contractId: string): Promise<void> {
    const { error } = await supabase
      .from('contracts')
      .update({ status: 'draft' })
      .eq('id', contractId);

    if (error) throw error;
  },
};

